import { render } from "./project-info.vue?vue&type=template&id=8f1fc4dc&scoped=true"
import script from "./project-info.vue?vue&type=script&lang=js"
export * from "./project-info.vue?vue&type=script&lang=js"

import "./project-info.vue?vue&type=style&index=0&id=8f1fc4dc&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f1fc4dc"]])

export default __exports__